import React, { useEffect, useRef, useState } from "react";
import RenderStatus from "../../../styles/styledStatus";
import { TimestampToDateMoment } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

import { StyledEventLogs } from "../../styledLogs";
import { StyledCol, StyledTableRow } from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const LogsItem = ({ value }) => {
  const { t } = useTranslation("logsPage");

  const [show, setShow] = useState(false);
  const [isOverflow, setIsOverflow] = useState(false);
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth
  });

  const handleResize = () => {
    setWindowSize({
      width: window.innerWidth
    });
  };

  const refHeight = useRef(null);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    setIsOverflow(refHeight.current.clientHeight >= 70);
  }, [windowSize.width]);

  return (
    <StyledTableRow
      scroll="auto"
      col="6"
      className="logs-table__row-system"
    >
      <StyledCol data-title={t("table.role")} className="logs-table__roles">
        {value.context.role.map((role, key) => (
          <span key={key}>{role}</span>
        ))}
      </StyledCol>
      <StyledCol inline data-title="E-mail">
        <StyledBreakWord as="p">
          {value.context.user}
        </StyledBreakWord>
      </StyledCol>
      <StyledCol inline data-title={t("table.levelName")}>
        <RenderStatus status={value.level_name ?? value.level} />
      </StyledCol>
      <StyledCol data-title={t("table.event")} className="logs-table__event">
        <StyledEventLogs ref={refHeight} show={show}>
          <StyledBreakWord as="p">
            {value.message}
          </StyledBreakWord>
        </StyledEventLogs>
        <button className={`read-more ${isOverflow && "read-more_is-overflow"} ${show && "read-more_active"}`} onClick={() => setShow(!show)}>
          {show ? t("table.hide") : t("table.detail")}
        </button>
      </StyledCol>
      <StyledCol data-title={t("table.date")}>
        {TimestampToDateMoment(value.datetime)}
      </StyledCol>
      <StyledCol data-title="IP">
        {value.context.ip ?? "systemIp"}
      </StyledCol>
    </StyledTableRow>
  );
};

export default LogsItem;